function getEnv() {
  const explicitEnv =
    process.env.NEXT_PUBLIC_APP_ENV || process.env.DEV_CONFIG || ''
  const vercelEnv =
    process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || ''
  const nodeEnv = process.env.NODE_ENV || ''
  const processEnv = explicitEnv || vercelEnv || nodeEnv || ''

  if (processEnv === 'production') {
    return 'production'
  }

  if (processEnv === 'staging' || processEnv === 'preview') {
    return 'staging'
  }

  if (processEnv === 'phase2') {
    return 'phase2'
  }

  return ''
}

export default getEnv
